import {Resource} from 'simpli-web-sdk'

export class PanelUserFlags extends Resource {
  idPanelUserFk: number = 0
  integrationEnabled: boolean = false
  hasControlTower: boolean = false
  unlimitedTransporterAccess: boolean = false
  limitMonthlyQueries: boolean = false
  apiEnabled: boolean = false
  permissionForSacPublic: boolean = false

  get $id() {
    return this.idPanelUserFk
  }
  get $tag() {
    return this.idPanelUserFk.toString()
  }
}
